import { combineReducers, createStore } from "redux";
import IDrawerMenus from "../interfaces/IDrawerMenus";
import * as actionTypes from "./actionTypes";
import { DispatchType, MenuAction } from "./types/types";
import menuReducer from "../reducers/menuReducer";

// eslint-disable-next-line
export function addMenu(menu: IDrawerMenus[]) {
  const action: MenuAction = {
    type: actionTypes.ADD_MENU,
    value: menu,
  };

  return (dispatch: DispatchType) => {
    dispatch(action);
  };
}

// eslint-disable-next-line
export function changeDrawer() {
  const action: MenuAction = {
    type: actionTypes.CHANGE_DRAWER,
  };

  return (dispatch: DispatchType) => {
    dispatch(action);
  };
}
export const setSelectedMenuId: any = (id: string) => ({
  type: "SET_SELECTED_MENU_ID",
  value: id,
});
const rootReducer = combineReducers({
  menu: menuReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const store = createStore(rootReducer);
export default store;
